import { SimpleEntity, SimpleEntityValidationError } from "../../../types";
import stripEmptyObjectProp from "../../../utils/stripEmptyObjectProp";
import validateEntityDescription from "../../../utils/validators/validateEntityDescription";
import validateEntityName from "../../../utils/validators/validateEntityName";

type GroupType = SimpleEntity & { groupType: string; alias: string };

export default function validateGroup({ name, description, groupType, alias }: GroupType): object {
   const errors = {} as SimpleEntityValidationError & { groupType: string; alias: string };
   errors.name = validateEntityName(name, "Group");
   errors.alias = validateEntityDescription(alias, { optional: true, entity: "Group alias" });
   errors.description = validateEntityDescription(description, { optional: false, entity: "Group" });
   errors.groupType = !Boolean(groupType) ? "Group type is required. Please select group type." : "";

   return stripEmptyObjectProp(errors);
}
